import { Link, useLocation } from 'react-router-dom';

const routeLabels: Record<string, string> = {
  '': 'Command Center',
  'outcomes-registry': 'Outcomes Registry',
  lots: 'Lots',
  studies: 'Studies',
  providers: 'Providers',
  investigators: 'Investigators',
  intelligence: 'Intelligence',
  'consent-access': 'Consent & Access',
  audit: 'Audit',
  'adverse-events': 'Adverse Events',
  compare: 'Compare',
  'ai-copilot': 'AI Co-pilot',
  settings: 'Settings',
  qc: 'Adverse Events',
  new: 'New Entry',
  patients: 'Outcomes Registry',
  reports: 'Intelligence',
  inventory: 'Inventory',
  references: 'References',
  'audit-log': 'Audit',
  lines: 'Lots',
};

export function getConsoleRouteLabel(segment: string): string {
  return routeLabels[segment] ?? decodeURIComponent(segment);
}

export function Breadcrumbs() {
  const location = useLocation();
  const segments = location.pathname.split('/').filter(Boolean);
  const consoleSegments = segments[0] === 'console' ? segments.slice(1) : segments;

  if (consoleSegments.length === 0) {
    return (
      <nav className="crumb" aria-label="Breadcrumb">
        <span className="ci cur">Command Center</span>
      </nav>
    );
  }

  return (
    <nav className="crumb" aria-label="Breadcrumb">
      <Link className="ci" to="/console">
        Command Center
      </Link>
      {consoleSegments.map((segment, i) => {
        const path = '/console/' + consoleSegments.slice(0, i + 1).join('/');
        const isLast = i === consoleSegments.length - 1;
        const label = getConsoleRouteLabel(segment);

        return (
          <span key={path} className="rl-crumb-seg">
            <span className="sep" aria-hidden="true">
              /
            </span>
            {isLast ? (
              <span className="ci cur">{label}</span>
            ) : (
              <Link className="ci" to={path}>
                {label}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}
